module.exports = __webpack_public_path__ + "static/media/aquash_logo.ddf169ec.png";